import React,{useState,useRef} from 'react';
import { useForm } from "react-hook-form";
import {Dialog,DialogContent,DialogTitle,DialogActions,Button,Divider} from "@material-ui/core";
import Input from '../../Utils/Input';
import realtimeDB, {db, storage} from "../../Utils/api";
import styled from "styled-components";
import useCategorias from '../../Hooks/useCategorias';
import ComboBox from '../../Utils/ComboBox';
import SecondaryButton from '../SecondaryButton';
import { useAllItems } from '../../Hooks/useItems';
import Alert from '../Alert';


const ContainerWithImage=styled.div`
width:100%;
display:grid;
grid-template-columns:100%;
grid-template-rows:1fr;

@media screen and (max-width: 500px)
{
    grid-template-columns:100%;
};`;

const ContainerWithoutImage=styled.div`
width:100%;`;


const ImageTemplate=styled.img`
width:100%;`;

const Container5050=styled.div`
display:grid;
align-items:center;
grid-template-columns:50% 50%;
grid-template-rows:1fr;`;

const Image = React.memo( function Image({ src }) 
{
    return <ImageTemplate src={src} />;
});

const PreviewImage=({Imagen})=>
{
 

    if(Imagen)
    {
        return <Image src={URL.createObjectURL(Imagen)}/>
    }
    else
    {
        return ""
    }
}


const AddItemModal = ({open,close}) => 
{
    const Items=useAllItems();
    const Categorias=useCategorias();

    const [Imagen, setImagen] = useState(null);
    const [Nombre, setNombre] = useState("");
    const [Precio, setPrecio] = useState("")
    const [Descripcion, setDescripcion] = useState("");
    const [DescripcionCorta, setDescripcionCorta] = useState("");
    const [Categoria, setCategoria] = useState("");
    const [Indice, setIndice] = useState("");

    const [Mensaje, setMensaje] = useState(undefined);

    const finishModal=()=>
    {
        setNombre("");
        setPrecio("");
        setDescripcion("");
        setDescripcionCorta("");
        setIndice("");
        setImagen(null);
        close();
    }

    const addItem=async ()=>
    {    
        const ID=Date.now();
        let finalCategoria=(Categoria=== "" || Categoria===undefined) ? Categorias[0].data.Nombre : Categoria;
        const ItemRef= realtimeDB.ref(`/Menu/Categorias/${finalCategoria}/Items`).child(ID)

        const ITEM=Items.filter(item => item.Nombre===Nombre);

        if(ITEM.length===0)
        {
            if(Imagen)
            {
                let imageRef = storage.ref().child(`images/${Nombre}`);

                const Snapshot = await imageRef.put(Imagen);
                const imagenURL=await imageRef.getDownloadURL();
             
                ItemRef.set
                ({
                    Nombre,
                    Estado:true,
                    Precio: Precio===undefined ? "" : Number(Precio),
                    Descripcion,
                    DescripcionCorta,
                    Indice:Number(Indice),
                    Categoria:finalCategoria,
                    Imagen:imagenURL
                }).then(finishModal());
            }
            else
            {
                const DefaultImage="https://baumlanus.s3.sa-east-1.amazonaws.com/Imagen_no_disponible_41b46cb63f.jpg";
                ItemRef.set
                ({
                    Nombre,
                    Estado:true,
                    Precio: Precio===undefined ? "" : Number(Precio),
                    Indice:Number(Indice),
                    Descripcion,
                    DescripcionCorta,
                    Categoria:finalCategoria,
                    Imagen:DefaultImage
                }).then(finishModal());
            }
        }
        else
        {
            setMensaje(`${Nombre} Ya existe`);
        }
    }

    const PickPhoto=()=>
    {
        
        const onChangeIMG=(event)=>
        {
            setImagen(event.target.files[0]);
        }

     
        return <div>
            <input accept="image/*"  id="icon-button-file" type="file" style={{display:"none"}} onChange={onChangeIMG}/>
            <label htmlFor="icon-button-file">
            <Button variant="contained" color="primary" component="span" style={{width:"100%",padding:"5px 7.5px"}}>
            {Imagen === null ?  "Seleccionar imagen" : "Cambiar imagen"}
            </Button>
            {Imagen ? <SecondaryButton style={{width:"100%",padding:"5px 7.5px",margin:"5px 0"}} onClick={() => setImagen(null)}>Remover imagen</SecondaryButton> : ""}
            </label>   
        </div>
    }

    let buttonDisabled=(Nombre==="" || ( Number(Precio)<=0 && Precio!=="") || Descripcion==="" || Indice==="" || Number(Indice) <= 0);

    return <Dialog open={open} onClose={close}>
        <DialogContent>
            <PreviewImage Imagen={Imagen}/>
            <Container5050>
                <Input label="Nombre" value={Nombre} changeValue={setNombre}/>
                <Input label="Precio" value={Precio} changeValue={setPrecio} type="number" />
            </Container5050>
            <Input label="Descripción" value={Descripcion} changeValue={setDescripcion}/>
            <Container5050>
                <Input label="Descripción corta" value={DescripcionCorta} changeValue={setDescripcionCorta}/>
                <ComboBox label="Categoria" options={Categorias} value={Categoria} changeValue={setCategoria}/>
            </Container5050>
            <Container5050>
                <Input type="number" label="Indice" value={Indice} changeValue={setIndice}/>
                <PickPhoto/>
            </Container5050>
            <Alert mensaje={Mensaje} close={() => setMensaje(undefined)}/>
        </DialogContent>
        <DialogActions>
         <Button color="primary" variant="outlined" onClick={close}>Cancelar</Button>
         <Button color="primary" variant="contained" onClick={addItem} disabled={buttonDisabled} >{Imagen===null ? "Confirmar sin imagen" : "Confirmar"}</Button>
        </DialogActions>
    </Dialog>
}

export default AddItemModal
